export default "/assets/images/virus-png.f782bf040fa98eeb.png";